<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
    style="border-radius: 8px"
  >
    <v-card>
      <v-card-title class="primary px-4">
        <div class="d-flex align-center">
          <v-btn color="white" icon :disabled="loading" @click="cancelAction"
            ><v-icon size="20px">mdi-close</v-icon></v-btn
          >
          <span
            class="white--text"
            style="font-size: 16px !important; font-weight: 400"
            >Áp dụng 2FA hàng loạt theo bộ phận</span
          >
        </div>
      </v-card-title>
      <v-card-text class="pt-4 black--text">
        <p class="mb-1 font-weight-500">Thao tác</p>
        <v-radio-group v-model="required" row hide-details class="mt-0 mb-4">
          <v-radio label="Bật bắt buộc 2FA" :value="true"></v-radio>
          <v-radio label="Tắt bắt buộc 2FA" :value="false"></v-radio>
        </v-radio-group>

        <p class="mb-1 font-weight-500">
          Bộ phận <span class="semantic_error--text">*</span>
        </p>
        <v-checkbox
          v-model="allDepartments"
          label="Tất cả bộ phận"
          hide-details
          dense
          class="mt-0 mb-2"
        ></v-checkbox>
        <div v-show="!allDepartments" class="neutral_color_sub3 rounded-lg">
          <SelectAuto
            :key="resetKey"
            :placeholder="'Chọn bộ phận'"
            :onChange="onChangeDepartments"
            :options="departments"
            multiple
            chips
            deletable-chips
          />
        </div>
        <p class="mt-3 mb-0 neutral--text" style="font-size: 13px">
          Chỉ tính người dùng có chức danh thuộc bộ phận đã chọn.
        </p>
      </v-card-text>
      <v-card-actions class="px-4 pb-4">
        <v-spacer></v-spacer>
        <v-btn
          color="neutral_color_sub4"
          class="rounded-lg"
          depressed
          :disabled="loading"
          @click="cancelAction"
        >
          Hủy
        </v-btn>
        <v-btn
          color="primary"
          class="rounded-lg"
          depressed
          :loading="loading"
          :disabled="!selectedDepartmentIds.length"
          @click="submit"
        >
          Áp dụng
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex"
import SelectAuto from "@/components/Filter/SelectAuto.vue"
export default {
  components: { SelectAuto },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    cancelAction: {
      type: Function,
      default() {},
    },
    // Receives { required, departmentIds }
    confirmAction: {
      type: Function,
      default() {},
    },
  },
  data() {
    return {
      dialog: false,
      required: true,
      allDepartments: false,
      departmentIds: [],
      resetKey: 0,
    }
  },
  computed: {
    ...mapState({
      departments: (state) => state.users.departments,
    }),
    selectedDepartmentIds() {
      if (this.allDepartments) {
        return this.departments.map((o) => o.id)
      }
      return this.departmentIds || []
    },
  },
  watch: {
    isVisible() {
      this.dialog = this.isVisible
      if (this.isVisible) {
        this.resetForm()
      }
    },
  },
  methods: {
    resetForm() {
      this.required = true
      this.allDepartments = false
      this.departmentIds = []
      this.resetKey += 1
    },
    onChangeDepartments(_val) {
      this.departmentIds = _val || []
    },
    submit() {
      if (!this.selectedDepartmentIds.length) {
        return
      }
      this.confirmAction({
        required: this.required,
        departmentIds: this.selectedDepartmentIds,
      })
    },
  },
}
</script>
